import { Backdrop, Box, Button, Checkbox, CircularProgress, Link, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toast } from 'react-toastify';
import { smsApp } from '../../feature/api/Download';
import Scan from './Scan';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const Call = ({ phone }) => {
    const isLoadingSms = useSelector(state => state.download.isLoadingSms)
    const dispatch = useDispatch()
    const [mobile, setMobile] = useState()
    const [bot, setBot] = useState(false)
    return (
        <Box display={"flex"} bgcolor={"#000"} flexDirection={phone ? "column" : "row"} alignItems={"center"} justifyContent={"space-between"} gap={3} p={!phone ? "30px 50px" : "10px"} >
            {phone && <Box position={"relative"} width={"100%"} p="20px" height="500px"    >
                <img src="/images/phoneBox.png" alt="" style={{ position: 'absolute' }} />
                <img src="/images/phone.png" alt="" style={{ position: 'absolute' }} />
            </Box>}
            <Box display={"flex"} flexDirection={"column"} gap={3}  >
                <Typography color="#EF7C00" fontSize={"24px"} fontWeight={700}>دانلود اپلیکیشن</Typography>
                <Box>
                    {/* <Link target='_blank' sx={{textDecoration:'none'}} display={"flex"} justifyContent={"space-between"} p="10px" borderBottom={"1px solid #fff"} alignItems={"center"}   href={ "https://trc.metrix.ir/cofhsk/"}>
                    <Typography color="#fff">دریافت از  گوگل پلی </Typography>
                    <img src="/images/googlePlay.png" alt=""  />
                </Link> */}
                    <Link target='_blank' sx={{ textDecoration: 'none' }} display={"flex"} justifyContent={"space-between"} p="10px" borderBottom={"1px solid #fff"} alignItems={"center"} href={"https://trc.metrix.ir/iwltku/"}>
                        <Typography color="#fff">دریافت از گالاکسی استور </Typography>
                        <img src="/images/playStore.png" alt="" />
                    </Link>
                    <Link target='_blank' sx={{ textDecoration: 'none' }} display={"flex"} justifyContent={"space-between"} p="10px" borderBottom={"1px solid #fff"} alignItems={"center"} href={"https://trc.metrix.ir/lr0vn5/"}>
                        <Typography color="#fff">دریافت از بازار</Typography>
                        <img src="/images/bazar.png" alt="" width={"35px"} height={"35px"} />
                    </Link>
                    <Link target='_blank' sx={{ textDecoration: 'none' }} display={"flex"} justifyContent={"space-between"} p="10px" borderBottom={"1px solid #fff"} alignItems={"center"} href={"https://trc.metrix.ir/7gpr62/"}>
                        <Typography color="#fff">دریافت از مایکت</Typography>
                        <img src="/images/myket.png" alt="" width={"35px"} height={"35px"} />
                    </Link>
                    <Link target='_blank' sx={{ textDecoration: 'none' }} display={"flex"} justifyContent={"space-between"} p="10px" borderBottom={"1px solid #fff"} alignItems={"center"} href={"https://trc.metrix.ir/emcnl1/"}>
                        <Typography color="#fff">دانلود مستقیم</Typography>
                        <img src="/images/downloadIcon.png" alt="" width={"35px"} height={"35px"} />
                    </Link>



                    <Link target='_blank' sx={{ textDecoration: 'none' }} display={"flex"} justifyContent={"space-between"} p="10px" borderBottom={"1px solid #fff"} alignItems={"center"} href={"https://trc.metrix.ir/x492pu/"}>
                        <Typography color="#fff" > نسخه وب اپلیکیشن مخصوص کاربران IOS </Typography>
                        <img src="/images/appStore.png" alt="" />
                    </Link>
                </Box>
                <Box display={"flex"} flexDirection={phone ? "column" : "row"} gap={2}>
                    {!phone && <Scan />}
                    <Box display={"flex"} flexDirection={"column"} gap={2}>
                        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={2}>
                            <Typography color="#fff" textAlign={"center"} fontWeight={700} fontSize={"20px"}>ارسال لینک از طریق پیامک</Typography>
                            <input value={mobile} onChange={(e) => setMobile(e.target.value)} type="tel" width={"100%"} style={{ borderRadius: '20px', border: '1px solid #EF7C00', backgroundColor: 'inherit', padding: '5px 20px', fontSize: '20px', fontWeight: 900, color: '#fff' }} placeholder='09123456789' />
                        </Box>
                        <Box border="1px solid #EF7C00" p="10px" display={"flex"} justifyContent={"space-between"}>
                            <Box display={"flex"} gap={1} alignItems={"center"}>
                                <Checkbox value={bot} onChange={() => setBot(!bot)} sx={{ border: '1px solid #EF7C00', borderRadius: 0, p: 0 }} />
                                <Typography color="#fff">من ربات نیستم</Typography>
                            </Box>

                            <img src="/images/captch.png" alt="" />
                        </Box>
                        <Box display={"flex"} justifyContent={"flex-end"}>
                            <Button onClick={() => {
                                if (bot) {
                                    if (mobile) {
                                        dispatch(smsApp({ mobile: mobile }))
                                        setMobile("")
                                        setBot(false)
                                    }
                                } else {
                                    toast.error('لطفا گزینه من ربات نیستم را فعال نمایید ')
                                }
                            }} variant='contained' sx={{ bgcolor: '#EF7C00', padding: '7px 40px', borderRadius: '30px' }}>ارسال</Button>

                        </Box>

                    </Box>

                </Box>
                {phone && <Scan />}
            </Box>
            {!phone && <Box position={"relative"} height="700px" width={"550px"} display={"flex"} justifyContent={"flex-end"} >
                <img src="/images/boxphonedesktop.png" alt="" style={{ position: 'absolute' }} height={"100%"} width={"509px"} />
                <img src="/images/phonedesktop.png" alt="" style={{ position: 'absolute', marginTop: '70px' }} height={"600px"} width="450px" />
            </Box>}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoadingSms}

            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    )
}

export default Call